import { createSlice } from "@reduxjs/toolkit";

export const loginSlice = createSlice({
  name: "login",
  initialState: {
    authData: {
      authToken: null,
      refreshToken: null,
      tokenTime: "",
      isAuthenticated: false,
    },
    userData: { role: "", email: "", username: "", name: "" },
  },
  reducers: {
    saveAuthData: (state, action) => {
      state.authData = action.payload;
    },
    saveUserData: (state, action) => {
      state.userData = action.payload;
    },
  },
});

export const { saveAuthData, saveUserData } = loginSlice.actions;

export default loginSlice.reducer;
